/**
 * Layout component that queries for data
 * with Gatsby's StaticQuery component
 *
 * See: https://www.gatsbyjs.org/docs/static-query/
 */

import React from 'react';
import PropTypes from 'prop-types';
import theme, { colors } from 'utils/styles/theme';
import './layout.css';
import Global from 'components/Global';
import Header from 'components/Header';
import Footer from 'components/Footer';
import Transition from 'components/Transition';
import Modal from 'components/Modal';
import Animate from 'components/Animate';
import Link from 'components/Link';
import Text from 'components/Text';
import { Flex } from 'components/Grid';
import H1 from 'components/H1';
import Image from 'components/Image';
import hypnosisImg from '../../images/spiral.svg';
import useModals from 'utils/hooks/useModals';

import { StaticQuery, graphql } from 'gatsby';
import { ThemeProvider } from 'styled-components';

const MENU_ITEMS = [
	{ to: '/vad-vi-gor', text: 'Vad vi gör?' },
	{ to: '/case', text: 'Kundcase' },
	{ to: '/nyheter', text: 'Nyheter' },
	{ to: '/kontakt', text: 'Kontakta oss' }
];

const Layout = props => {
	const { children } = props;

	const { toggleModal, modals } = useModals({
		menu: false,
		hypnosis: false
	});

	const renderMenuItems = MENU_ITEMS.map((item, key) => (
		<Animate
			on={modals.menu}
			leaving={!modals.menu}
			key={key}
			delay={key * 100 + 200}
			animation="slideUp"
		>
			<Link
				cursor="pointerWhite"
				className="WhiteCursor"
				to={item.to}
				onClick={() => toggleModal('menu')}
			>
				<Text fontFamily="headlines" fontWeight="bold" fontSize="h1">
					{item.text}
				</Text>
			</Link>
		</Animate>
	));

	return (
		<StaticQuery
			query={graphql`
				query SiteTitleQuery {
					site {
						siteMetadata {
							title
						}
					}
				}
			`}
			render={data => (
				<ThemeProvider theme={{ ...theme, mode: 'regular' }}>
					<>
						<Global />
						<Header
							siteTitle={data.site.siteMetadata.title}
							modals={modals}
							toggleModal={toggleModal}
							invertedColors={modals.menu || modals.hypnosis ? true : false}
						/>
						<Transition location={props.location}>{children}</Transition>
						<Modal
							visible={modals.menu}
							color="client.accent"
							justifyContent="center"
							alignItems="center"
							flexDirection="column"
						>
							{renderMenuItems}
						</Modal>
						<Modal
							justifyContent="center"
							alignItems="center"
							flexDirection="column"
							color="client.primary"
							visible={modals.hypnosis}
							cursor="pointerWhite"
							as="a"
							href="/kontakt"
						>
							<Image bg objectFit="cover" staticImg src={hypnosisImg} />
							<Flex p={[4, 8]}>
								<H1 fontSize={['h3', 'h1']} lineHeight={1.27} textAlign="center">
									<span
										style={{
											WebkitTextStroke: '2px ' + colors.client.primary,
											color: 'white'
										}}
									>
										Du känner dig sömnig och kroppen är tung som bly. När vi räknat till tre och
										knäpper med fingrarna kommer du att vakna upp och vilja bli kund hos oss. 1,2,3.
										Knäpp!
									</span>
								</H1>
							</Flex>
						</Modal>
						<Footer siteMap={MENU_ITEMS} />
					</>
				</ThemeProvider>
			)}
		/>
	);
};

Layout.propTypes = {
	children: PropTypes.node.isRequired,
	location: PropTypes.object
};

export default Layout;
